<template>
  <v-expansion-panels v-model="panel" multiple color="#fff">
    <v-expansion-panel class="mt-5">
      <v-expansion-panel-title
        class="d-flex justify-start"
        hide-actions
        expand-icon="fa-solid fa-plus"
        collapse-icon="fa-solid fa-minus"
      >
        <v-icon v-if="!panel.includes(0)" icon="fa-solid fa-plus" />
        <v-icon v-if="panel.includes(0)" icon="fa-solid fa-minus" />
        <h3>Span {{ strUnitLabel }} Details</h3>
      </v-expansion-panel-title>
      <v-expansion-panel-text eager>
        <SuperstructureSpanDetails :structureUnit="structureUnit" />
      </v-expansion-panel-text>
    </v-expansion-panel>
    <v-expansion-panel class="mt-5">
      <v-expansion-panel-title
        class="d-flex justify-start"
        hide-actions
        expand-icon="fa-solid fa-plus"
        collapse-icon="fa-solid fa-minus"
      >
        <v-icon v-if="!panel.includes(1)" icon="fa-solid fa-plus" />
        <v-icon v-if="panel.includes(1)" icon="fa-solid fa-minus" />
        <h3>Span {{ strUnitLabel }} Superstructure Notes</h3>
      </v-expansion-panel-title>
      <v-expansion-panel-text eager>
        <SuperstructureSpanNotes :structureUnitId="structureUnitId" />
      </v-expansion-panel-text>
    </v-expansion-panel>
    <v-expansion-panel class="mt-5">
      <v-expansion-panel-title
        class="d-flex justify-start"
        hide-actions
        expand-icon="fa-solid fa-plus"
        collapse-icon="fa-solid fa-minus"
      >
        <v-icon v-if="!panel.includes(2)" icon="fa-solid fa-plus" />
        <v-icon v-if="panel.includes(2)" icon="fa-solid fa-minus" />
        <h3>Span {{ strUnitLabel }} Protective Coating Notes</h3>
      </v-expansion-panel-title>
      <v-expansion-panel-text eager>
        <SuperstructureSpanProtectiveCoatingNotes :structureUnitId="structureUnitId" />
      </v-expansion-panel-text>
    </v-expansion-panel>
    <v-expansion-panel class="mt-5">
      <v-expansion-panel-title
        class="d-flex justify-start"
        hide-actions
        expand-icon="fa-solid fa-plus"
        collapse-icon="fa-solid fa-minus"
      >
        <v-icon v-if="!panel.includes(3)" icon="fa-solid fa-plus" />
        <v-icon v-if="panel.includes(3)" icon="fa-solid fa-minus" />
        <h3>Span {{ strUnitLabel }} NSTM Details</h3>
      </v-expansion-panel-title>
      <v-expansion-panel-text eager>
        <SuperstructureSpanNSTMDetails :strUnitKey="strUnitKey" :moduleType="moduleType" />
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script setup>
import { computed, ref, toRefs } from "vue";
import SuperstructureSpanDetails from "./superstructureSpanDetails.vue";
import SuperstructureSpanNotes from "./superstructureSpanNotes.vue";
import SuperstructureSpanProtectiveCoatingNotes from "./superstructureSpanProtectiveCoatingNotes.vue";
import SuperstructureSpanNSTMDetails from "./superstructureSpanNSTMDetails.vue";
import { storeToRefs } from "pinia";
import { useSuperstructureStore } from "@/components/inspection/store/superStructure";

const props = defineProps({
  strUnitKey: Number,
  moduleType: String,
});
const { strUnitKey } = toRefs(props);
const store = useSuperstructureStore();

const { superStructureData } = storeToRefs(store);
const structureUnit = computed(() =>
  superStructureData.value.structureUnits.find((item) => item.strUnitKey === strUnitKey.value)
);

const structureUnitId = computed(() => {
  return structureUnit.value.structureUnitId;
});
const strUnitLabel = computed(() => {
  return structureUnit.value.strUnitLabel;
});
let panel = ref([0, 1, 2, 3]);
</script>
